import { render, staticRenderFns } from "./Reservations.vue?vue&type=template&id=01c2523e&scoped=true&"
import script from "./Reservations.vue?vue&type=script&lang=js&"
export * from "./Reservations.vue?vue&type=script&lang=js&"
import style0 from "./Reservations.vue?vue&type=style&index=0&id=01c2523e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2523e",
  null
  
)

export default component.exports